module.exports = __webpack_public_path__ + "static/img/index-2.ef48633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happyBirthday/index-2.png
// module id = 3GqF
// module chunks = 1